export const PROJECT_INFO = {
  title: "Судовий Хаб",
  shortTitle: "API судових даних",
  description: "Уніфікований доступ до Єдиного державного реєстру судових рішень, Єдиного реєстру боржників та Автоматизованої системи виконавчого провадження.",
  problem: "Судові рішення, відомості про боржників та виконавчі провадження розпорошені по різних державних джерелах і форматах.",
  solution: "Судовий Хаб агрегує, структурує та надає єдиний REST API доступ до Єдиного державного реєстру судових рішень, Єдиного реєстру боржників та Автоматизованої системи виконавчого провадження.",
  businessValue: "Журналісти, дослідники, юридичні фахівці та громадські активісти можуть легко шукати й аналізувати судові справи, дані про боржників та виконавчі провадження.",
};

export const FEATURES = [
  {
    title: "Судові рішення",
    description: "Пошук і фільтрація судових документів за номером справи, кодом судді, категорією, назвою суду та датою ухвалення.",
  },
  {
    title: "Реєстр боржників",
    description: "Доступ до Єдиного реєстру боржників – фільтрація за кодом боржника, датою народження, ПІБ або номером виконавчого провадження.",
  },
  {
    title: "Виконавчі провадження",
    description: "Перегляд виконавчих проваджень з фільтрацією за кодом ДВС, номером провадження, кодом боржника/стягувача та ПІБ боржника.",
  },
  {
    title: "Курсорна пагінація",
    description: "Ефективна навігація по великих наборах даних за допомогою курсорної пагінації (без обмеження 10 тис. записів).",
  },
  {
    title: "REST API з JWT",
    description: "Автентифікація за допомогою JWT токенів (термін дії 30 хв) та доступ до даних через документований REST API.",
  },
  {
    title: "Повнотекстовий пошук",
    description: "Пошук за ПІБ боржника (повнотекстовий) – автоматичне ігнорування сортування.",
  },
];

export const API_ENDPOINTS = [
  { method: "GET", path: "/api/v1/lakehouse/debt/debt", description: "Пошук записів про боржників з фільтрацією та пагінацією." },
  { method: "GET", path: "/api/v1/lakehouse/debt/debt/{debt_id}", description: "Отримання одного запису про боржника за debt_id." },
  { method: "GET", path: "/api/v1/lakehouse/enforcement/enforcement", description: "Пошук виконавчих проваджень з фільтрацією та пагінацією." },
  { method: "GET", path: "/api/v1/lakehouse/enforcement/enforcement/{enforcement_id}", description: "Отримання одного виконавчого провадження за enforcement_id." },
  { method: "GET", path: "/api/v1/lakehouse/court-documents/court-cases", description: "Пошук судових документів з фільтрацією та пагінацією." },
  { method: "GET", path: "/api/v1/lakehouse/court-documents/court-cases/{number}", description: "Отримання одного судового документа за номером справи." },
];

export const API_LIMITS = {
  rateLimit: "60 запитів на хвилину на токен",
  tokenLifetime: "30 хвилин",
  paginationLimit: "200 записів на запит (максимум)",
};

export const QUERY_PARAMETERS = {
  debtor_search: ["debtor_code", "debtor_birthdate", "debtor_name", "vp_ordernum", "limit", "page", "cursor", "sort_by", "order"],
  enforcement_search: ["dvs_code", "vp_ordernum", "debtor_code", "creditor_code", "debtor_birthdate", "debtor_name", "limit", "page", "cursor", "sort_by", "order"],
  court_documents: ["cause_num", "judgment_code", "category_code", "limit", "page", "cursor", "sort_by", "order"],
};

// User roles description (kept as before)
export const USER_ROLES = {
  ADMIN: "Адміністратор системи — керує обліковими записами, ролями, моніторингом.",
  OPERATOR: "Оператор імпортів — налаштовує конектори, запускає ETL-процеси.",
  ANALYST: "Аналітик/Інтегратор — споживає REST API для аналітичних систем.",
  AUDITOR: "Аудитор/Журналіст — перевіряє походження й цілісність даних.",
};